import { Element } from "../Element.mjs";
import { isBoolean, isEnum, isObject, isUuid } from "../validation/index.mjs";
export var StoryBookmarkNode;

(function (StoryBookmarkNode) {
  StoryBookmarkNode.TYPE = 'story-bookmark';
  var Layout;

  (function (Layout) {
    Layout["VERTICAL"] = "vertical";
    Layout["HORIZONTAL"] = "horizontal";
  })(Layout = StoryBookmarkNode.Layout || (StoryBookmarkNode.Layout = {}));

  function isStoryBookmarkNode(value) {
    return Element.isElement(value, StoryBookmarkNode.TYPE);
  }

  StoryBookmarkNode.isStoryBookmarkNode = isStoryBookmarkNode;

  function validateStoryBookmarkNode(value) {
    var isValid = isStoryBookmarkNode(value) && isUuid(value.uuid) && isObject(value.story) && isUuid(value.story.uuid) && isEnum(value.layout, Layout) && isBoolean(value.show_thumbnail) && isBoolean(value.new_tab);
    return isValid ? value : null;
  }

  StoryBookmarkNode.validateStoryBookmarkNode = validateStoryBookmarkNode;
})(StoryBookmarkNode || (StoryBookmarkNode = {}));